export const MANITIZED_CHANELL_EDITTOR_TEXT = "MANITIZED_CHANELL_EDITTOR_TEXT";
export const CHANEL_FILE_UPLOAD_VALUE = "CHANEL_FILE_UPLOAD_VALUE";
export const CHANEL_VOICE_UPLOAD_VALUE = "CHANEL_VOICE_UPLOAD_VALUE";
export const GET_BOARD_CHANNEL_TOPICS = "GET_BOARD_CHANNEL_TOPICS";
export const GET_BOARD_CHANNEL_MESSAGES = "GET_BOARD_CHANNEL_MESSAGES";
export const SET_CHANNEL_MESSAGES_LOADING = "SET_CHANNEL_MESSAGES_LOADING";
export const SET_CHANNEL_MESSAGES_LOADING_FALSE = "SET_CHANNEL_MESSAGES_LOADING_FALSE";
export const EDIT_TASKMAP_MESSAGE = "EDIT_TASKMAP_MESSAGE";
export const EDIT_TASK_MESSAGE = "EDIT_TASK_MESSAGE";
export const EDIT_BOARD_CHANNEL_MESSAGE = "EDIT_BOARD_CHANNEL_MESSAGE";
export const GET_BOARD_TASKMAP_CHANNEL_MESSAGES = "GET_BOARD_TASKMAP_CHANNEL_MESSAGES";
export const GET_BOARD_TASK_CHANNEL_MESSAGES = "GET_BOARD_TASK_CHANNEL_MESSAGES";
export const REMOVE_EDDITOR_TEXT = "REMOVE_EDDITOR_TEXT";

// Older messages (infinite scroll upward)
export const BOARD_CHANNEL_LOAD_OLDER_REQUEST = "BOARD_CHANNEL_LOAD_OLDER_REQUEST";
export const BOARD_CHANNEL_LOAD_OLDER_SUCCESS = "BOARD_CHANNEL_LOAD_OLDER_SUCCESS";
export const BOARD_CHANNEL_LOAD_OLDER_FAIL = "BOARD_CHANNEL_LOAD_OLDER_FAIL";

export const TASKMAP_CHANNEL_LOAD_OLDER_REQUEST = "TASKMAP_CHANNEL_LOAD_OLDER_REQUEST";
export const TASKMAP_CHANNEL_LOAD_OLDER_SUCCESS = "TASKMAP_CHANNEL_LOAD_OLDER_SUCCESS";
export const TASKMAP_CHANNEL_LOAD_OLDER_FAIL = "TASKMAP_CHANNEL_LOAD_OLDER_FAIL";

export const TASK_CHANNEL_LOAD_OLDER_REQUEST = "TASK_CHANNEL_LOAD_OLDER_REQUEST";
export const TASK_CHANNEL_LOAD_OLDER_SUCCESS = "TASK_CHANNEL_LOAD_OLDER_SUCCESS";
export const TASK_CHANNEL_LOAD_OLDER_FAIL = "TASK_CHANNEL_LOAD_OLDER_FAIL";